var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRevenue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 28,
    viewBox: "0 0 38 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 7.33335V24C37.3334 25.8334 35.8334 27.3334 34.0001 27.3334H7.33341C6.41675 27.3334 5.66675 26.5834 5.66675 25.6667C5.66675 24.75 6.41675 24 7.33341 24H34.0001V7.33335C34.0001 6.41669 34.7501 5.66669 35.6667 5.66669C36.5834 5.66669 37.3334 6.41669 37.3334 7.33335ZM5.66675 20.6667C2.90008 20.6667 0.666748 18.4334 0.666748 15.6667V5.66669C0.666748 2.90002 2.90008 0.666687 5.66675 0.666687H25.6667C28.4334 0.666687 30.6667 2.90002 30.6667 5.66669V17.3334C30.6667 19.1667 29.1667 20.6667 27.3334 20.6667H5.66675ZM10.6667 10.6667C10.6667 13.4334 12.9001 15.6667 15.6667 15.6667C18.4334 15.6667 20.6667 13.4334 20.6667 10.6667C20.6667 7.90002 18.4334 5.66669 15.6667 5.66669C12.9001 5.66669 10.6667 7.90002 10.6667 10.6667Z",
    fill: "#0052CC"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRevenue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/revenue.3fb35a15.svg";
export { ForwardRef as ReactComponent };